import React from "react";
import {
    StyledReadyArrow,
    StyledReadyBody,
    StyledReadyCheck,
    StyledReadyCode,
    StyledReadyHeader,
    StyledReadyHeaderSpacer,
    StyledReadyHeaderTitle,
    StyledReadyItem,
    StyledReadyList,
    StyledReadyName,
    StyledReadyStateText,
} from "./ModuleReadinessPopover.styles";

/**
 * Collapsible "Ready Modules" section shown inside ModuleReadinessPopover.
 * @param {Array<object>} ready Ready modules to list when expanded.
 * @param {boolean} expanded Whether the list is expanded.
 * @param {Function} onToggle Toggles `expanded`.
 */
function ModuleReadinessReadyModules({ ready, expanded, onToggle }) {
    return (
        <>
            <StyledReadyHeader
                type="button"
                $expanded={expanded}
                aria-expanded={expanded}
                onClick={onToggle}
            >
                <StyledReadyHeaderTitle>
                    <i
                        className={`fal fa-chevron-${expanded ? "up" : "right"}`}
                        aria-hidden="true"
                    />
                    Ready Modules
                </StyledReadyHeaderTitle>

                <StyledReadyHeaderSpacer />

                <StyledReadyStateText>
                    {expanded ? "expanded" : "collapsed"}
                </StyledReadyStateText>
            </StyledReadyHeader>

            {expanded && (
                <StyledReadyBody>
                    <StyledReadyList>
                        {ready.map((item, index) => (
                            <StyledReadyItem key={`${item.moduleCode}-ready-${index}`}>
                                <StyledReadyCheck>✓</StyledReadyCheck>
                                <StyledReadyName>
                                    {item.moduleName || "Module"}
                                </StyledReadyName>
                                <StyledReadyArrow>→</StyledReadyArrow>
                                <StyledReadyCode>
                                    {item.linkedCode || item.moduleCode || "-"}
                                </StyledReadyCode>
                            </StyledReadyItem>
                        ))}
                    </StyledReadyList>
                </StyledReadyBody>
            )}
        </>
    );
}

export default ModuleReadinessReadyModules;
